


























































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import CustomersDropdown from "./CustomersDropdown.vue";
import ContactUs from "@/components/elements/modal/ContactUs.vue";
import { Order } from "@/models/order/order";
import { AuthError, GenericError } from "@/services/error_service";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";
import AuthService from "@/services/auth_service";
import { Mobile } from "@/mixins/mobile";
import UIkit from "uikit";

@Component({
  components: {
    CustomersDropdown,
    ContactUs,
  },
})
export default class Header extends mixins(Auth, Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetAssignedCustomer))
  customer!: string;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  order!: Order;
  protected menuIsOpen = false;
  protected authService = new AuthService();

  protected showContactUsModal = false;
  protected showNewQuoteModal = false;

  protected toggleContactUsModal() {
    this.showContactUsModal = true;
  }

  protected closeContactUsModal(): void {
    this.showContactUsModal = false;
  }

  mounted() {
    const sidebar: any = document.getElementById("offcanvas-nav");
    //@ts-ignore
    UIkit.util.on(sidebar, "hide", () => {
      this.menuIsOpen = false;
    });
    //@ts-ignore
    UIkit.util.on(sidebar, "show", () => {
      this.menuIsOpen = true;
    });
  }

  get totalQty(): number {
    let qty = 0;
    if (this.order.items && this.order.items.length) {
      for (const item of this.order.items) {
        qty = qty + item.qty;
      }
    }
    return qty;
  }

  public async logout(): Promise<void> {
    try {
      this.setLoggedIn(false);
      this.setUserRole(null);
      await this.authService.logout();
      window.location.replace(
        `${process.env.VUE_APP_LOGIN_URL}?returnURL=${process.env.VUE_APP_URL}/`
      );
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else {
        GenericError.popup(err.message);
      }
    }
  }
}
